import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import { TransitionMixin, media } from '../../helpers';

const WeddingBannerContainer = styled.div`
    position: relative;

    .content-container {
        text-align: center;

        ${media.large`top: 28%;left: 0;width: 100%; position: absolute;`}
        ${media.laptop`top: 30%;`}

        .inner-wrap {
            max-width: 65vw;
            margin: 0 auto;

            h3 {
                color: #fff;
                font-size: 3.1rem;
                margin: 0 0 40px;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                ${media.xl`font-size: 4rem;`}
            }

            .btn-container {
                a {
                    border: 1px solid #f74c34;
                    background-color: #f74c34;
                    color: #fff;
                    border-radius: 5px;
                    font-weight: 800;
                    padding: 12px 30px;
                    font-size: 1rem;
                    font-family: neue-kabel, sans-serif;
                    text-decoration: none;
                    display: inline-block;
                    ${TransitionMixin('.25s')}

                    &:hover {
                        background-color: #fff;
                        color: #f74c34;
                    }
                }
            }
        }
    }
`;

const WeddingBanner = ({ content }) => {
    const { bannerImage, bannerButton, bannerHeadline } = content || {};
    return (
        <WeddingBannerContainer>
            <div className="image-container">
                <Img fluid={bannerImage.localFile.childImageSharp.fluid} />

                <div className="content-container">
                    <div className="inner-wrap">
                        <h3>{bannerHeadline}</h3>
                        <div className="btn-container">
                            <Link to={bannerButton.url}>
                                {bannerButton.title}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </WeddingBannerContainer>
    );
};

export default WeddingBanner;
